import PrimaryButton from "components/buttons/primary-button";

import Typography from "components/typography";
import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  close: () => void;
  confirm?: () => void;
  header?: string;
  confirmText?: string;
  cancelText?: string;
  children?: React.ReactNode;
  twoButtons?: boolean;
  disableConfirm?: boolean;
  width?: string;
  footer?: boolean;
  loading?: boolean;
}
const ModalTemplate = ({
  close,
  confirm = () => {},
  header = "",
  confirmText,
  cancelText,
  children,
  twoButtons,
  disableConfirm = false,
  width = "53.4rem",
  footer = true,
  loading
}: IProps) => {
  return (
    <Container width={width}>
      <Header>
        <Typography color={Colors.white300} weight="semibold">
          {header}
        </Typography>
        <CancelIcon onClick={close}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15.8327 4.1665L4.16602 15.8332M4.16602 4.1665L15.8327 15.8332"
              stroke="#DDDDDD"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </CancelIcon>
      </Header>
      <Body>{children}</Body>
      {footer && (
        <Footer>
          {twoButtons ? (
            <ButtonGrid>
              <PrimaryButton
                text={cancelText}
                onClick={close}
                variant={"p-fade"}
              />
              <PrimaryButton
                text={confirmText}
                loading={loading}
                onClick={confirm}
                disabled={disableConfirm}
              />
            </ButtonGrid>
          ) : (
            <PrimaryButton
              text={confirmText}
              loading={loading}
              onClick={confirm}
              disabled={disableConfirm}
            />
          )}
        </Footer>
      )}
    </Container>
  );
};

export default ModalTemplate;

const Container = styled.div<{ width: string }>`
  border-radius: 0.8rem;
  width: ${(props) => props.width};
  overflow: hidden;
  background-color: ${Colors.grey1000};
  @media only screen and (max-width: 769px) {
    width: 100%;
    min-width: 45rem;
  }
`;

const Header = styled.div`
  width: 100%;
  padding: 1.6rem;
  background-color: ${Colors.grey700};
  border-bottom: 0.5px solid ${Colors.grey600};
  background: var(--Grey-700, #1e1e1e);
  display: flex;
  justify-content: space-between;
`;

const CancelIcon = styled.div`
  cursor: pointer;
  width: 2rem;
  height: 2rem;
`;

const Body = styled.div`
  background-color: ${Colors.grey1000};

  padding: 3.9rem 2.5rem;
`;

const Footer = styled.div`
  width: 100%;
  padding: 2rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 0.5px solid ${Colors.grey600};
`;

const ButtonGrid = styled.div`
  width: 100%;
  display: grid;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: auto auto;
`;
